import React from 'react';
import { createRoot } from 'react-dom/client';
import PopupMainContainer from './PopupMainContainer.js';

const root = createRoot(document.getElementById('REACT_popup'));
root.render(<PopupMainContainer {...window._THULEDATA._popup} />);
